import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import {CardMedia} from "@material-ui/core";
const styles = (theme) => ({
  root: {
    color: theme.palette.common.white,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    height: '100vh',
    minHeight: 500,
    maxHeight: 1300,
    // [theme.breakpoints.up('sm')]: {
    // },
  },
  container: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(14),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  backdrop: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.5,
    zIndex: -1,
  },
  background: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    zIndex: -2,
    minHeight: 500,
    maxHeight: 1300,
    height: '100vh',
    // [theme.breakpoints.up('sm')]: {
    //   height: '80vh',
    //   minHeight: 500,
    //   maxHeight: 1300,
    // },
  },
  arrowDown: {
    position: 'absolute',
    bottom: theme.spacing(4),
  },
});

const backgroundImage =
   `../html/stars.html`;
function ProductHeroLayout(props) {
  const { backgroundClassName, children, classes } = props;

  return (
    <section className={classes.root}>
      <Container className={classes.container}>
        {children}
        <div className={classes.backdrop} />
        <CardMedia
          className={clsx(classes.background, backgroundClassName)}
          // style={{ display: 'none' }}
          image={backgroundImage}
          alt="increase priority"
          component="iframe"

        />
        {/*<div className={clsx(classes.background, backgroundClassName)} >*/}
        {/*</div>*/}
        {/*<img*/}
        {/*  className={classes.arrowDown}*/}
        {/*  src="/static/themes/onepirate/productHeroArrowDown.png"*/}
        {/*  height="16"*/}
        {/*  width="12"*/}
        {/*  alt="arrow down"*/}
        {/*/>*/}
      </Container>
    </section>
  );
}

ProductHeroLayout.propTypes = {
  backgroundClassName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProductHeroLayout);
